import { useArtistContext } from "Components";

export const useProfileCompletion = () => {
  const { privateProfileData } = useArtistContext();

  const profileCompletionPercentage = Math.round(
    (privateProfileData?.data()?.completion?.total || 0) * 100,
  );

  return {
    profileCompletionPercentage,
    isProfileComplete: profileCompletionPercentage === 100,
  };
};
